import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Invoices screen — shares the View frame with the real content. */
export function InvoicesPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        <View.Body>
          <Skeleton variant="block" height={120} />

          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={200} height={24} />
            <Skeleton variant="text" width={240} height={24} />
          </div>

          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={160} height={24} />
            <Skeleton variant="block" height={144} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
